import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {CrystalClearFrontUrl} from "../../../../shared/pages/crystal-clear-front-url";
import {
  ClearingAllocationPlResidualService
} from "../../../../services/clearing/clearing-allocation-pl-residual.service";

@Component({
  selector: 'app-pl-residual-table-button',
  templateUrl: './pl-residual-table-button-component.html',
  styleUrls: ['./pl-residual-table-button-component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlResidualTableButtonComponent extends CcBaseComponent {

  @Input()
  buttonTitle: string = 'page.clearing.pl-residual.title';
  @Input()
  transPartKey: string = 'clearing.pl-residual';
  CrystalClearFrontUrl = CrystalClearFrontUrl;

  inProgressCount: number = 0;

  @Input()
  selectedOrderIds: string[];
  @Input()
  tradeModeEnabled: boolean;

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              protected plResidualService: ClearingAllocationPlResidualService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);

  }



}
